function _define_property(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _object_spread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _define_property(target, key, source[key]);
        });
    }
    return target;
}
function ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        if (enumerableOnly) {
            symbols = symbols.filter(function(sym) {
                return Object.getOwnPropertyDescriptor(object, sym).enumerable;
            });
        }
        keys.push.apply(keys, symbols);
    }
    return keys;
}
function _object_spread_props(target, source) {
    source = source != null ? source : {};
    if (Object.getOwnPropertyDescriptors) {
        Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
        ownKeys(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}
import findIndex from 'lodash/findIndex';
import get from 'lodash/get';
import { registerAction, unregisterAction } from 'helpers/reducerTools';
import { SET_NEW_CONFIGURATION_VERSION } from 'modules/App/actionTypes';
import * as actionTypes from './actionTypes';
const initialState = {
    isAuthenticated: false,
    passphrase: null,
    invitationCode: null,
    account: null,
    walletEntriesList: [],
    accountCCAccessToken: null,
    activeProfileType: null,
    activeClinicMembershipId: null,
    activeOrganizationUID: null,
    activeHcpInvitationId: null,
    hcpProfile: null,
    patientProfile: null,
    cgProfile: null,
    countrySettings: null,
    hcpCustomIdentifiers: [],
    patientDataFromInvitation: null,
    patientHealthDataFromInvitation: null,
    payers: [],
    metricsUnits: null,
    hasElevatedPermissions: false,
    elevatedPermissionsMode: null,
    gdprData: {},
    tokenExpired: false,
    changePasswordReset: false,
    fetching: [],
    sending: [],
    errors: []
};
export default function reducer(state = _object_spread({}, initialState), action = {}) {
    switch(action.type){
        case actionTypes.GET_ME:
            {
                return _object_spread_props(_object_spread({}, state), {
                    fetching: registerAction(state.fetching, actionTypes.GET_ME),
                    errors: unregisterAction(state.errors, actionTypes.GET_ME)
                });
            }
        case actionTypes.GET_ME_SUCCESS:
            {
                const { isAuthenticated, account, hcpProfile, patientProfile, cgProfile, metricsUnits } = action.payload;
                // TODO: fix when BE exposes proper fields on updateAccountSettings EP
                if (metricsUnits) {
                    metricsUnits.cholesterol = metricsUnits.bloodGlucoseConcentration;
                    metricsUnits.triglycerides = metricsUnits.bloodGlucoseConcentration;
                }
                return _object_spread_props(_object_spread({}, state), {
                    isAuthenticated: !!isAuthenticated,
                    account,
                    hcpProfile,
                    patientProfile,
                    cgProfile,
                    metricsUnits,
                    fetching: unregisterAction(state.fetching, actionTypes.GET_ME)
                });
            }
        case actionTypes.GET_ME_ERROR:
            {
                return _object_spread_props(_object_spread({}, state), {
                    isAuthenticated: false,
                    fetching: unregisterAction(state.fetching, actionTypes.GET_ME),
                    errors: registerAction(state.errors, actionTypes.GET_ME)
                });
            }
        //------------------------------------------------------------------------------------------------------------------
        case actionTypes.SET_ACTIVE_PROFILE_TYPE:
            {
                const { activeProfileType } = action.payload;
                return _object_spread_props(_object_spread({}, state), {
                    activeProfileType
                });
            }
        //------------------------------------------------------------------------------------------------------------------
        case actionTypes.LIST_WALLET_ENTRIES:
            {
                return _object_spread_props(_object_spread({}, state), {
                    fetching: registerAction(state.fetching, actionTypes.LIST_WALLET_ENTRIES),
                    errors: unregisterAction(state.errors, actionTypes.LIST_WALLET_ENTRIES)
                });
            }
        case actionTypes.LIST_WALLET_ENTRIES_SUCCESS:
            {
                const { walletEntriesList } = action.payload;
                return _object_spread_props(_object_spread({}, state), {
                    walletEntriesList,
                    fetching: unregisterAction(state.fetching, actionTypes.LIST_WALLET_ENTRIES)
                });
            }
        case actionTypes.LIST_WALLET_ENTRIES_ERROR:
            {
                return _object_spread_props(_object_spread({}, state), {
                    fetching: unregisterAction(state.fetching, actionTypes.LIST_WALLET_ENTRIES),
                    errors: registerAction(state.errors, actionTypes.LIST_WALLET_ENTRIES)
                });
            }
        //------------------------------------------------------------------------------------------------------------------
        case actionTypes.FETCH_PATIENT_DATA_FROM_INVITATION:
            {
                return _object_spread_props(_object_spread({}, state), {
                    patientDataFromInvitation: null,
                    fetching: registerAction(state.fetching, actionTypes.FETCH_PATIENT_DATA_FROM_INVITATION),
                    errors: unregisterAction(state.errors, actionTypes.FETCH_PATIENT_DATA_FROM_INVITATION)
                });
            }
        case actionTypes.FETCH_PATIENT_DATA_FROM_INVITATION_SUCCESS:
            {
                const { patientDataFromInvitation } = action.payload;
                return _object_spread_props(_object_spread({}, state), {
                    patientDataFromInvitation,
                    fetching: unregisterAction(state.fetching, actionTypes.FETCH_PATIENT_DATA_FROM_INVITATION)
                });
            }
        case actionTypes.FETCH_PATIENT_DATA_FROM_INVITATION_ERROR:
            {
                return _object_spread_props(_object_spread({}, state), {
                    patientDataFromInvitation: null,
                    fetching: unregisterAction(state.fetching, actionTypes.FETCH_PATIENT_DATA_FROM_INVITATION),
                    errors: registerAction(state.errors, actionTypes.FETCH_PATIENT_DATA_FROM_INVITATION)
                });
            }
        //------------------------------------------------------------------------------------------------------------------
        case actionTypes.FETCH_PATIENT_HEALTH_DATA_FROM_INVITATION:
            {
                return _object_spread_props(_object_spread({}, state), {
                    patientDataFromInvitation: null,
                    fetching: registerAction(state.fetching, actionTypes.FETCH_PATIENT_HEALTH_DATA_FROM_INVITATION),
                    errors: unregisterAction(state.errors, actionTypes.FETCH_PATIENT_HEALTH_DATA_FROM_INVITATION)
                });
            }
        case actionTypes.FETCH_PATIENT_HEALTH_DATA_FROM_INVITATION_SUCCESS:
            {
                const { patientHealthDataFromInvitation } = action.payload;
                return _object_spread_props(_object_spread({}, state), {
                    patientHealthDataFromInvitation,
                    fetching: unregisterAction(state.fetching, actionTypes.FETCH_PATIENT_HEALTH_DATA_FROM_INVITATION)
                });
            }
        case actionTypes.FETCH_PATIENT_HEALTH_DATA_FROM_INVITATION_ERROR:
            {
                return _object_spread_props(_object_spread({}, state), {
                    patientDataFromInvitation: null,
                    fetching: unregisterAction(state.fetching, actionTypes.FETCH_PATIENT_HEALTH_DATA_FROM_INVITATION),
                    errors: registerAction(state.errors, actionTypes.FETCH_PATIENT_HEALTH_DATA_FROM_INVITATION)
                });
            }
        //------------------------------------------------------------------------------------------------------------------
        case actionTypes.SET_ACTIVE_CLINIC_MEMBERSHIP_ID:
            {
                const { activeClinicMembershipId, activeOrganizationUID } = action.payload;
                return _object_spread_props(_object_spread({}, state), {
                    activeClinicMembershipId,
                    activeOrganizationUID,
                    activeHcpInvitationId: null
                });
            }
        case actionTypes.SET_ACTIVE_CLINIC_MEMBERSHIP_CLEARED:
            {
                const { activeClinicMembershipId, hcpProfile } = state;
                const idx = findIndex(hcpProfile.clinicHcpMemberships, {
                    clinicHcpMembershipId: activeClinicMembershipId
                });
                if (idx < 0) {
                    return state;
                }
                const clinicHcpMemberships = [
                    ...hcpProfile.clinicHcpMemberships
                ];
                const clinicMembership = _object_spread({}, clinicHcpMemberships[idx]);
                clinicMembership.clinic.clinicStatus = 'Cleared';
                clinicHcpMemberships[idx] = clinicMembership;
                return _object_spread_props(_object_spread({}, state), {
                    hcpProfile: _object_spread_props(_object_spread({}, state.hcpProfile), {
                        clinicHcpMemberships
                    })
                });
            }
        case actionTypes.SET_CLINIC_MEMBERSHIP_HAS_ACTIVE_NOTIFICATIONS:
            {
                const { hasActiveNotifications, clinicHcpMembershipId } = action.payload;
                const { hcpProfile } = state;
                const idx = findIndex(hcpProfile.clinicHcpMemberships, {
                    clinicHcpMembershipId
                });
                if (idx < 0) {
                    return state;
                }
                const clinicHcpMemberships = [
                    ...hcpProfile.clinicHcpMemberships
                ];
                const clinicMembership = _object_spread({}, clinicHcpMemberships[idx]);
                clinicMembership.hasActiveNotifications = hasActiveNotifications;
                clinicHcpMemberships[idx] = clinicMembership;
                return _object_spread_props(_object_spread({}, state), {
                    hcpProfile: _object_spread_props(_object_spread({}, state.hcpProfile), {
                        clinicHcpMemberships
                    })
                });
            }
        // BackOffice UPDATE -----------------------------------------------------------------------------------------------
        case SET_NEW_CONFIGURATION_VERSION:
            {
                const { payers, countrySettings, supportedDevices } = action.payload;
                const patientProfile = state.patientProfile ? _object_spread_props(_object_spread({}, state.patientProfile), {
                    supportedDevices
                }) : state.patientProfile;
                return _object_spread_props(_object_spread({}, state), {
                    payers,
                    countrySettings,
                    patientProfile
                });
            }
        //------------------------------------------------------------------------------------------------------------------
        case actionTypes.SIGN_OUT:
            {
                return _object_spread_props(_object_spread({}, state), {
                    isAuthenticated: false,
                    sending: registerAction(state.sending, actionTypes.SIGN_OUT),
                    errors: unregisterAction(state.errors, actionTypes.SIGN_OUT)
                });
            }
        case actionTypes.SIGN_OUT_ERROR:
            {
                return _object_spread_props(_object_spread({}, state), {
                    sending: unregisterAction(state.sending, actionTypes.SIGN_OUT),
                    errors: registerAction(state.errors, actionTypes.SIGN_OUT)
                });
            }
        //------------------------------------------------------------------------------------------------------------------
        case actionTypes.SET_ELEVATED_PERMISSIONS_MODE:
            {
                return _object_spread_props(_object_spread({}, state), {
                    elevatedPermissionsMode: action.payload,
                    hasElevatedPermissions: false
                });
            }
        case actionTypes.ELEVATE_PERMISSIONS:
            {
                return _object_spread_props(_object_spread({}, state), {
                    sending: registerAction(state.sending, actionTypes.ELEVATE_PERMISSIONS),
                    errors: unregisterAction(state.errors, actionTypes.ELEVATE_PERMISSIONS)
                });
            }
        case actionTypes.ELEVATE_PERMISSIONS_SUCCESS:
            {
                return _object_spread_props(_object_spread({}, state), {
                    hasElevatedPermissions: true,
                    sending: unregisterAction(state.sending, actionTypes.ELEVATE_PERMISSIONS)
                });
            }
        case actionTypes.ELEVATE_PERMISSIONS_ERROR:
            {
                return _object_spread_props(_object_spread({}, state), {
                    hasElevatedPermissions: false,
                    sending: unregisterAction(state.sending, actionTypes.ELEVATE_PERMISSIONS),
                    errors: registerAction(state.errors, actionTypes.ELEVATE_PERMISSIONS)
                });
            }
        case actionTypes.ELEVATE_PERMISSIONS_TIMEOUT:
            {
                return _object_spread_props(_object_spread({}, state), {
                    hasElevatedPermissions: false
                });
            }
        //------------------------------------------------------------------------------------------------------------------
        case actionTypes.GENERATE_KEYS_PEM:
            {
                return _object_spread_props(_object_spread({}, state), {
                    sending: registerAction(state.sending, actionTypes.GENERATE_KEYS_PEM),
                    errors: unregisterAction(state.errors, actionTypes.GENERATE_KEYS_PEM)
                });
            }
        case actionTypes.GENERATE_KEYS_PEM_SUCCESS:
            {
                const { prvKeyPem, pubKeyPem, passphrase, encryptedPassphrase } = action.payload;
                const account = _object_spread_props(_object_spread({}, state.account), {
                    passphrase,
                    encryptedPassphrase,
                    keyPair: {
                        prvKeyPem,
                        pubKeyPem
                    }
                });
                return _object_spread_props(_object_spread({}, state), {
                    account,
                    sending: unregisterAction(state.sending, actionTypes.GENERATE_KEYS_PEM)
                });
            }
        case actionTypes.GENERATE_KEYS_PEM_ERROR:
            {
                return _object_spread_props(_object_spread({}, state), {
                    sending: unregisterAction(state.sending, actionTypes.GENERATE_KEYS_PEM),
                    errors: registerAction(state.errors, actionTypes.GENERATE_KEYS_PEM)
                });
            }
        //------------------------------------------------------------------------------------------------------------------
        case actionTypes.SET_KEYS:
            {
                const { prvKeyPem, pubKeyPem, encryptedPassphrase } = action.payload;
                const account = _object_spread_props(_object_spread({}, state.account), {
                    encryptedPassphrase,
                    keyPair: {
                        prvKeyPem,
                        pubKeyPem
                    }
                });
                return _object_spread_props(_object_spread({}, state), {
                    account,
                    sending: unregisterAction(state.sending, actionTypes.GENERATE_KEYS_PEM)
                });
            }
        //------------------------------------------------------------------------------------------------------------------
        case actionTypes.GET_PASSPHRASE_SUCCESS:
            {
                const { passphrase } = action.payload;
                return _object_spread_props(_object_spread({}, state), {
                    passphrase
                });
            }
        //------------------------------------------------------------------------------------------------------------------
        case actionTypes.UPDATE_ACCOUNT_SETTINGS:
            {
                return _object_spread_props(_object_spread({}, state), {
                    sending: registerAction(state.sending, actionTypes.UPDATE_ACCOUNT_SETTINGS),
                    errors: unregisterAction(state.errors, actionTypes.UPDATE_ACCOUNT_SETTINGS)
                });
            }
        case actionTypes.UPDATE_ACCOUNT_SETTINGS_SUCCESS:
            {
                const { metricsUnits, account } = state;
                // TODO: fix when BE exposes proper fields on updateAccountSettings EP
                const concentrationUnit = get(action.payload, 'settings.glucoseLevelUnitTypes');
                metricsUnits.bloodGlucoseConcentration = concentrationUnit;
                metricsUnits.cholesterol = concentrationUnit;
                metricsUnits.triglycerides = concentrationUnit;
                const settings = _object_spread({}, account.settings, action.payload.settings);
                return _object_spread_props(_object_spread({}, state), {
                    metricsUnits,
                    account: _object_spread_props(_object_spread({}, state.account), {
                        settings
                    }),
                    sending: unregisterAction(state.sending, actionTypes.UPDATE_ACCOUNT_SETTINGS)
                });
            }
        case actionTypes.UPDATE_ACCOUNT_SETTINGS_ERROR:
            {
                return _object_spread_props(_object_spread({}, state), {
                    sending: unregisterAction(state.sending, actionTypes.UPDATE_ACCOUNT_SETTINGS),
                    errors: registerAction(state.errors, actionTypes.UPDATE_ACCOUNT_SETTINGS)
                });
            }
        //------------------------------------------------------------------------------------------------------------------
        case actionTypes.DELETE_ACCOUNT:
            {
                return _object_spread_props(_object_spread({}, state), {
                    sending: registerAction(state.sending, actionTypes.DELETE_ACCOUNT),
                    errors: unregisterAction(state.errors, actionTypes.DELETE_ACCOUNT)
                });
            }
        case actionTypes.DELETE_ACCOUNT_SUCCESS:
            {
                return _object_spread_props(_object_spread({}, state), {
                    sending: unregisterAction(state.sending, actionTypes.DELETE_ACCOUNT)
                });
            }
        case actionTypes.DELETE_ACCOUNT_ERROR:
            {
                return _object_spread_props(_object_spread({}, state), {
                    sending: unregisterAction(state.sending, actionTypes.DELETE_ACCOUNT),
                    errors: registerAction(state.errors, actionTypes.DELETE_ACCOUNT)
                });
            }
        //------------------------------------------------------------------------------------------------------------------
        case actionTypes.CREATE_PATIENT_PROFILE:
            {
                return _object_spread_props(_object_spread({}, state), {
                    sending: registerAction(state.sending, actionTypes.CREATE_PATIENT_PROFILE),
                    errors: unregisterAction(state.errors, actionTypes.CREATE_PATIENT_PROFILE)
                });
            }
        case actionTypes.CREATE_PATIENT_PROFILE_SUCCESS:
            {
                const { patientProfile } = action.payload;
                return _object_spread_props(_object_spread({}, state), {
                    patientProfile,
                    patientDataFromInvitation: null,
                    sending: unregisterAction(state.sending, actionTypes.CREATE_PATIENT_PROFILE)
                });
            }
        case actionTypes.CREATE_PATIENT_PROFILE_ERROR:
            {
                return _object_spread_props(_object_spread({}, state), {
                    sending: unregisterAction(state.sending, actionTypes.CREATE_PATIENT_PROFILE),
                    errors: registerAction(state.errors, actionTypes.CREATE_PATIENT_PROFILE)
                });
            }
        //------------------------------------------------------------------------------------------------------------------
        case actionTypes.UPDATE_PATIENT_PROFILE:
            {
                return _object_spread_props(_object_spread({}, state), {
                    sending: registerAction(state.sending, actionTypes.UPDATE_PATIENT_PROFILE),
                    errors: unregisterAction(state.errors, actionTypes.UPDATE_PATIENT_PROFILE)
                });
            }
        case actionTypes.UPDATE_PATIENT_PROFILE_SUCCESS:
            {
                const { patientProfile } = action.payload;
                return _object_spread_props(_object_spread({}, state), {
                    patientProfile: _object_spread({}, state.patientProfile, patientProfile),
                    sending: unregisterAction(state.sending, actionTypes.UPDATE_PATIENT_PROFILE)
                });
            }
        case actionTypes.UPDATE_PATIENT_PROFILE_ERROR:
            {
                return _object_spread_props(_object_spread({}, state), {
                    sending: unregisterAction(state.sending, actionTypes.UPDATE_PATIENT_PROFILE),
                    errors: registerAction(state.errors, actionTypes.UPDATE_PATIENT_PROFILE)
                });
            }
        //------------------------------------------------------------------------------------------------------------------
        case actionTypes.CONNECT_TO_PATIENT_STORAGE:
            {
                return _object_spread_props(_object_spread({}, state), {
                    sending: registerAction(state.sending, actionTypes.CONNECT_TO_PATIENT_STORAGE),
                    errors: unregisterAction(state.errors, actionTypes.CONNECT_TO_PATIENT_STORAGE)
                });
            }
        case actionTypes.CONNECT_TO_PATIENT_STORAGE_SUCCESS:
            {
                const { patientProfile } = action.payload;
                return _object_spread_props(_object_spread({}, state), {
                    patientProfile: _object_spread({}, state.patientProfile, patientProfile),
                    sending: unregisterAction(state.sending, actionTypes.CONNECT_TO_PATIENT_STORAGE)
                });
            }
        case actionTypes.CONNECT_TO_PATIENT_STORAGE_ERROR:
            {
                return _object_spread_props(_object_spread({}, state), {
                    sending: unregisterAction(state.sending, actionTypes.CONNECT_TO_PATIENT_STORAGE),
                    errors: registerAction(state.errors, actionTypes.CONNECT_TO_PATIENT_STORAGE)
                });
            }
        //------------------------------------------------------------------------------------------------------------------
        case actionTypes.FETCH_COUNTRY_SETTINGS:
            {
                return _object_spread_props(_object_spread({}, state), {
                    fetching: registerAction(state.fetching, actionTypes.FETCH_COUNTRY_SETTINGS),
                    errors: unregisterAction(state.errors, actionTypes.FETCH_COUNTRY_SETTINGS)
                });
            }
        case actionTypes.FETCH_COUNTRY_SETTINGS_SUCCESS:
            {
                const { countrySettings } = action.payload;
                return _object_spread_props(_object_spread({}, state), {
                    countrySettings,
                    fetching: unregisterAction(state.fetching, actionTypes.FETCH_COUNTRY_SETTINGS)
                });
            }
        case actionTypes.FETCH_COUNTRY_SETTINGS_ERROR:
            {
                return _object_spread_props(_object_spread({}, state), {
                    fetching: unregisterAction(state.fetching, actionTypes.FETCH_COUNTRY_SETTINGS),
                    errors: registerAction(state.errors, actionTypes.FETCH_COUNTRY_SETTINGS)
                });
            }
        //------------------------------------------------------------------------------------------------------------------
        case actionTypes.FETCH_PATIENT_PROFILE_SUPPORTED_DEVICES:
            {
                return _object_spread_props(_object_spread({}, state), {
                    fetching: registerAction(state.fetching, actionTypes.FETCH_PATIENT_PROFILE_SUPPORTED_DEVICES),
                    errors: unregisterAction(state.errors, actionTypes.FETCH_PATIENT_PROFILE_SUPPORTED_DEVICES)
                });
            }
        case actionTypes.FETCH_PATIENT_PROFILE_SUPPORTED_DEVICES_SUCCESS:
            {
                const { supportedDevices } = action.payload;
                const patientProfile = _object_spread_props(_object_spread({}, state.patientProfile), {
                    supportedDevices
                });
                return _object_spread_props(_object_spread({}, state), {
                    patientProfile,
                    fetching: unregisterAction(state.fetching, actionTypes.FETCH_PATIENT_PROFILE_SUPPORTED_DEVICES)
                });
            }
        case actionTypes.FETCH_PATIENT_PROFILE_SUPPORTED_DEVICES_ERROR:
            {
                return _object_spread_props(_object_spread({}, state), {
                    fetching: unregisterAction(state.fetching, actionTypes.FETCH_PATIENT_PROFILE_SUPPORTED_DEVICES),
                    errors: registerAction(state.errors, actionTypes.FETCH_PATIENT_PROFILE_SUPPORTED_DEVICES)
                });
            }
        //------------------------------------------------------------------------------------------------------------------
        case actionTypes.FETCH_PAYERS:
            {
                return _object_spread_props(_object_spread({}, state), {
                    fetching: registerAction(state.fetching, actionTypes.FETCH_PAYERS),
                    errors: unregisterAction(state.errors, actionTypes.FETCH_PAYERS)
                });
            }
        case actionTypes.FETCH_PAYERS_SUCCESS:
            {
                const { payers } = action.payload;
                return _object_spread_props(_object_spread({}, state), {
                    payers,
                    fetching: unregisterAction(state.fetching, actionTypes.FETCH_PAYERS)
                });
            }
        case actionTypes.FETCH_PAYERS_ERROR:
            {
                return _object_spread_props(_object_spread({}, state), {
                    fetching: unregisterAction(state.fetching, actionTypes.FETCH_PAYERS),
                    errors: registerAction(state.errors, actionTypes.FETCH_PAYERS)
                });
            }
        //------------------------------------------------------------------------------------------------------------------
        case actionTypes.CREATE_CG_PROFILE:
            {
                return _object_spread_props(_object_spread({}, state), {
                    sending: registerAction(state.sending, actionTypes.CREATE_CG_PROFILE),
                    errors: unregisterAction(state.errors, actionTypes.CREATE_CG_PROFILE)
                });
            }
        case actionTypes.CREATE_CG_PROFILE_SUCCESS:
            {
                const { cgProfile } = action.payload;
                return _object_spread_props(_object_spread({}, state), {
                    cgProfile,
                    sending: unregisterAction(state.sending, actionTypes.CREATE_CG_PROFILE)
                });
            }
        case actionTypes.CREATE_CG_PROFILE_ERROR:
            {
                return _object_spread_props(_object_spread({}, state), {
                    sending: unregisterAction(state.sending, actionTypes.CREATE_CG_PROFILE),
                    errors: registerAction(state.errors, actionTypes.CREATE_CG_PROFILE)
                });
            }
        //------------------------------------------------------------------------------------------------------------------
        case actionTypes.UPDATE_CG_PROFILE:
            {
                return _object_spread_props(_object_spread({}, state), {
                    sending: registerAction(state.sending, actionTypes.UPDATE_CG_PROFILE),
                    errors: unregisterAction(state.errors, actionTypes.UPDATE_CG_PROFILE)
                });
            }
        case actionTypes.UPDATE_CG_PROFILE_SUCCESS:
            {
                const { cgProfile } = action.payload;
                return _object_spread_props(_object_spread({}, state), {
                    cgProfile: _object_spread({}, state.cgProfile, cgProfile),
                    sending: unregisterAction(state.sending, actionTypes.UPDATE_CG_PROFILE)
                });
            }
        case actionTypes.UPDATE_CG_PROFILE_ERROR:
            {
                return _object_spread_props(_object_spread({}, state), {
                    sending: unregisterAction(state.sending, actionTypes.UPDATE_CG_PROFILE),
                    errors: registerAction(state.errors, actionTypes.UPDATE_CG_PROFILE)
                });
            }
        //------------------------------------------------------------------------------------------------------------------
        case actionTypes.CREATE_HCP_PROFILE:
            {
                return _object_spread_props(_object_spread({}, state), {
                    sending: registerAction(state.sending, actionTypes.CREATE_HCP_PROFILE),
                    errors: unregisterAction(state.errors, actionTypes.CREATE_HCP_PROFILE)
                });
            }
        case actionTypes.CREATE_HCP_PROFILE_SUCCESS:
            {
                const { hcpProfile } = action.payload;
                return _object_spread_props(_object_spread({}, state), {
                    hcpProfile,
                    sending: unregisterAction(state.sending, actionTypes.CREATE_HCP_PROFILE)
                });
            }
        case actionTypes.CREATE_HCP_PROFILE_ERROR:
            {
                return _object_spread_props(_object_spread({}, state), {
                    sending: unregisterAction(state.sending, actionTypes.CREATE_HCP_PROFILE),
                    errors: registerAction(state.errors, actionTypes.CREATE_HCP_PROFILE)
                });
            }
        //------------------------------------------------------------------------------------------------------------------
        case actionTypes.UPDATE_HCP_PROFILE:
            {
                return _object_spread_props(_object_spread({}, state), {
                    sending: registerAction(state.sending, actionTypes.UPDATE_HCP_PROFILE),
                    errors: unregisterAction(state.errors, actionTypes.UPDATE_HCP_PROFILE)
                });
            }
        case actionTypes.UPDATE_HCP_PROFILE_SUCCESS:
            {
                const { hcpProfile } = action.payload;
                return _object_spread_props(_object_spread({}, state), {
                    hcpProfile: _object_spread({}, state.hcpProfile, hcpProfile),
                    sending: unregisterAction(state.sending, actionTypes.UPDATE_HCP_PROFILE)
                });
            }
        case actionTypes.UPDATE_HCP_PROFILE_ERROR:
            {
                return _object_spread_props(_object_spread({}, state), {
                    sending: unregisterAction(state.sending, actionTypes.UPDATE_HCP_PROFILE),
                    errors: registerAction(state.errors, actionTypes.UPDATE_HCP_PROFILE)
                });
            }
        //------------------------------------------------------------------------------------------------------------------
        case actionTypes.FETCH_HCP_CUSTOM_IDENTIFIERS:
            {
                return _object_spread_props(_object_spread({}, state), {
                    fetching: registerAction(state.fetching, actionTypes.FETCH_HCP_CUSTOM_IDENTIFIERS),
                    errors: unregisterAction(state.errors, actionTypes.FETCH_HCP_CUSTOM_IDENTIFIERS)
                });
            }
        case actionTypes.FETCH_HCP_CUSTOM_IDENTIFIERS_SUCCESS:
            {
                const { hcpCustomIdentifiers } = action.payload;
                return _object_spread_props(_object_spread({}, state), {
                    hcpCustomIdentifiers,
                    fetching: unregisterAction(state.fetching, actionTypes.FETCH_HCP_CUSTOM_IDENTIFIERS)
                });
            }
        case actionTypes.FETCH_HCP_CUSTOM_IDENTIFIERS_ERROR:
            {
                return _object_spread_props(_object_spread({}, state), {
                    fetching: unregisterAction(state.fetching, actionTypes.FETCH_HCP_CUSTOM_IDENTIFIERS),
                    errors: registerAction(state.errors, actionTypes.FETCH_HCP_CUSTOM_IDENTIFIERS)
                });
            }
        //------------------------------------------------------------------------------------------------------------------
        case actionTypes.FETCH_MEMBERSHIPS:
            {
                return _object_spread_props(_object_spread({}, state), {
                    fetching: registerAction(state.fetching, actionTypes.FETCH_MEMBERSHIPS),
                    errors: unregisterAction(state.errors, actionTypes.FETCH_MEMBERSHIPS)
                });
            }
        case actionTypes.FETCH_MEMBERSHIPS_SUCCESS:
            {
                const { clinicHcpMemberships } = action.payload;
                return _object_spread_props(_object_spread({}, state), {
                    hcpProfile: _object_spread_props(_object_spread({}, state.hcpProfile), {
                        clinicHcpMemberships
                    }),
                    fetching: unregisterAction(state.fetching, actionTypes.FETCH_MEMBERSHIPS)
                });
            }
        case actionTypes.FETCH_MEMBERSHIPS_ERROR:
            {
                return _object_spread_props(_object_spread({}, state), {
                    fetching: unregisterAction(state.fetching, actionTypes.FETCH_MEMBERSHIPS),
                    errors: registerAction(state.errors, actionTypes.FETCH_MEMBERSHIPS)
                });
            }
        //------------------------------------------------------------------------------------------------------------------
        case actionTypes.CHECK_MEMBERSHIPS:
            {
                return _object_spread_props(_object_spread({}, state), {
                    fetching: registerAction(state.fetching, actionTypes.CHECK_MEMBERSHIPS),
                    errors: unregisterAction(state.errors, actionTypes.CHECK_MEMBERSHIPS)
                });
            }
        case actionTypes.CHECK_MEMBERSHIPS_SUCCESS:
            {
                const { organizationMembershipsWithoutClinics } = action.payload;
                return _object_spread_props(_object_spread({}, state), {
                    hcpProfile: _object_spread_props(_object_spread({}, state.hcpProfile), {
                        organizationMembershipsWithoutClinics
                    }),
                    fetching: unregisterAction(state.fetching, actionTypes.CHECK_MEMBERSHIPS)
                });
            }
        case actionTypes.CHECK_MEMBERSHIPS_ERROR:
            {
                return _object_spread_props(_object_spread({}, state), {
                    fetching: unregisterAction(state.fetching, actionTypes.CHECK_MEMBERSHIPS),
                    errors: registerAction(state.errors, actionTypes.CHECK_MEMBERSHIPS)
                });
            }
        //------------------------------------------------------------------------------------------------------------------
        case actionTypes.VALIDATE_MEMBERSHIPS:
            {
                return _object_spread_props(_object_spread({}, state), {
                    fetching: registerAction(state.fetching, actionTypes.VALIDATE_MEMBERSHIPS),
                    errors: unregisterAction(state.errors, actionTypes.VALIDATE_MEMBERSHIPS)
                });
            }
        case actionTypes.VALIDATE_MEMBERSHIPS_SUCCESS:
            {
                return _object_spread_props(_object_spread({}, state), {
                    fetching: unregisterAction(state.fetching, actionTypes.VALIDATE_MEMBERSHIPS)
                });
            }
        case actionTypes.VALIDATE_MEMBERSHIPS_ERROR:
            {
                return _object_spread_props(_object_spread({}, state), {
                    fetching: unregisterAction(state.fetching, actionTypes.VALIDATE_MEMBERSHIPS),
                    errors: registerAction(state.errors, actionTypes.VALIDATE_MEMBERSHIPS)
                });
            }
        //------------------------------------------------------------------------------------------------------------------
        case actionTypes.CONNECT_TO_CLINIC:
            {
                return _object_spread_props(_object_spread({}, state), {
                    sending: registerAction(state.sending, actionTypes.CONNECT_TO_CLINIC),
                    errors: unregisterAction(state.errors, actionTypes.CONNECT_TO_CLINIC)
                });
            }
        case actionTypes.CONNECT_TO_CLINIC_SUCCESS:
            {
                const { clinicHcpMembershipId, accessToken, passphrase, profilesReferenceKey, supportedDevices } = action.payload;
                if (!state.hcpProfile) {
                    throw new Error('No HCP profile'); // @TODO: LocalError?
                }
                const clinicHcpMemberships = [
                    ...get(state.hcpProfile, 'clinicHcpMemberships', [])
                ];
                const clinicMembershipIdx = findIndex(clinicHcpMemberships, (membership)=>membership.clinicHcpMembershipId === clinicHcpMembershipId);
                const clinicMembership = clinicHcpMemberships[clinicMembershipIdx];
                const { clinic } = clinicMembership;
                clinicHcpMemberships[clinicMembershipIdx] = _object_spread_props(_object_spread({}, clinicMembership), {
                    accessToken: accessToken || clinicMembership.accessToken,
                    passphrase: passphrase || clinicMembership.passphrase,
                    clinic: _object_spread_props(_object_spread({}, clinic), {
                        profilesReferenceKey: profilesReferenceKey || clinic.profilesReferenceKey,
                        supportedDevices: supportedDevices || clinic.supportedDevices
                    })
                });
                const hcpProfile = _object_spread_props(_object_spread({}, state.hcpProfile), {
                    clinicHcpMemberships
                });
                return _object_spread_props(_object_spread({}, state), {
                    hcpProfile,
                    sending: unregisterAction(state.sending, actionTypes.CONNECT_TO_CLINIC)
                });
            }
        case actionTypes.CONNECT_TO_CLINIC_ERROR:
            {
                return _object_spread_props(_object_spread({}, state), {
                    sending: unregisterAction(state.sending, actionTypes.CONNECT_TO_CLINIC),
                    errors: registerAction(state.errors, actionTypes.CONNECT_TO_CLINIC)
                });
            }
        //------------------------------------------------------------------------------------------------------------------
        case actionTypes.GDPR_FETCH_ACCOUNT_DUMP:
            {
                return _object_spread_props(_object_spread({}, state), {
                    fetching: registerAction(state.fetching, actionTypes.GDPR_FETCH_ACCOUNT_DUMP),
                    errors: unregisterAction(state.errors, actionTypes.GDPR_FETCH_ACCOUNT_DUMP)
                });
            }
        case actionTypes.GDPR_FETCH_ACCOUNT_DUMP_SUCCESS:
            {
                const { account } = action.payload;
                return _object_spread_props(_object_spread({}, state), {
                    gdprData: _object_spread_props(_object_spread({}, state.gdprData), {
                        account
                    }),
                    fetching: unregisterAction(state.fetching, actionTypes.GDPR_FETCH_ACCOUNT_DUMP)
                });
            }
        case actionTypes.GDPR_FETCH_ACCOUNT_DUMP_ERROR:
            {
                return _object_spread_props(_object_spread({}, state), {
                    fetching: unregisterAction(state.fetching, actionTypes.GDPR_FETCH_ACCOUNT_DUMP),
                    errors: registerAction(state.errors, actionTypes.GDPR_FETCH_ACCOUNT_DUMP)
                });
            }
        //------------------------------------------------------------------------------------------------------------------
        case actionTypes.GDPR_SET_PHI_SET:
            {
                const { phiSet } = action.payload;
                return _object_spread_props(_object_spread({}, state), {
                    gdprData: _object_spread_props(_object_spread({}, state.gdprData), {
                        phiSet
                    })
                });
            }
        //------------------------------------------------------------------------------------------------------------------
        case actionTypes.GDPR_SET_CLOUD_DRIVE_DUMP:
            {
                const { dump } = action.payload;
                const { readingsMonthlyBatches, cgmReadingsMonthlyBatches, measurementsMonthlyBatches, imports } = dump;
                return _object_spread_props(_object_spread({}, state), {
                    gdprData: _object_spread_props(_object_spread({}, state.gdprData), {
                        readingsMonthlyBatches,
                        cgmReadingsMonthlyBatches,
                        measurementsMonthlyBatches,
                        imports
                    })
                });
            }
        //------------------------------------------------------------------------------------------------------------------
        case actionTypes.GDPR_CLEAR_DATA:
            {
                return _object_spread_props(_object_spread({}, state), {
                    gdprData: {}
                });
            }
        //------------------------------------------------------------------------------------------------------------------
        case actionTypes.GDPR_SAVE_TO_FILE:
            {
                return _object_spread_props(_object_spread({}, state), {
                    fetching: registerAction(state.fetching, actionTypes.GDPR_SAVE_TO_FILE),
                    errors: unregisterAction(state.errors, actionTypes.GDPR_SAVE_TO_FILE)
                });
            }
        case actionTypes.GDPR_SAVE_TO_FILE_SUCCESS:
            {
                return _object_spread_props(_object_spread({}, state), {
                    gdprData: {},
                    fetching: unregisterAction(state.fetching, actionTypes.GDPR_SAVE_TO_FILE)
                });
            }
        case actionTypes.GDPR_SAVE_TO_FILE_ERROR:
            {
                return _object_spread_props(_object_spread({}, state), {
                    fetching: unregisterAction(state.fetching, actionTypes.GDPR_SAVE_TO_FILE),
                    errors: registerAction(state.errors, actionTypes.GDPR_SAVE_TO_FILE)
                });
            }
        //------------------------------------------------------------------------------------------------------------------
        case actionTypes.SET_CHANGE_PASSWORD_RESET:
            {
                const { changePasswordReset } = action.payload;
                return _object_spread_props(_object_spread({}, state), {
                    changePasswordReset
                });
            }
        //------------------------------------------------------------------------------------------------------------------
        case actionTypes.UPDATE_NOTIFICATIONS_SETTINGS:
            {
                return _object_spread_props(_object_spread({}, state), {
                    fetching: registerAction(state.fetching, actionTypes.UPDATE_NOTIFICATIONS_SETTINGS),
                    errors: unregisterAction(state.errors, actionTypes.UPDATE_NOTIFICATIONS_SETTINGS)
                });
            }
        case actionTypes.UPDATE_NOTIFICATIONS_SETTINGS_SUCCESS:
            {
                return _object_spread_props(_object_spread({}, state), {
                    fetching: unregisterAction(state.fetching, actionTypes.UPDATE_NOTIFICATIONS_SETTINGS)
                });
            }
        case actionTypes.UPDATE_NOTIFICATIONS_SETTINGS_ERROR:
            {
                return _object_spread_props(_object_spread({}, state), {
                    fetching: unregisterAction(state.fetching, actionTypes.UPDATE_NOTIFICATIONS_SETTINGS),
                    errors: registerAction(state.errors, actionTypes.UPDATE_NOTIFICATIONS_SETTINGS)
                });
            }
        //------------------------------------------------------------------------------------------------------------------
        case actionTypes.GET_CC_ACCESS_TOKEN_SUCCESS:
            {
                const { accessToken } = action.payload;
                return _object_spread_props(_object_spread({}, state), {
                    accountCCAccessToken: accessToken
                });
            }
        case actionTypes.GET_CC_ACCESS_TOKEN_ERROR:
            {
                return _object_spread_props(_object_spread({}, state), {
                    accountCCAccessToken: null
                });
            }
        //------------------------------------------------------------------------------------------------------------------
        case actionTypes.FETCH_NOTIFICATIONS_SETTING:
            {
                return _object_spread_props(_object_spread({}, state), {
                    patientDataFromInvitation: null,
                    fetching: registerAction(state.fetching, actionTypes.FETCH_NOTIFICATIONS_SETTING),
                    errors: unregisterAction(state.errors, actionTypes.FETCH_NOTIFICATIONS_SETTING)
                });
            }
        case actionTypes.FETCH_NOTIFICATIONS_SETTING_SUCCESS:
            {
                const { account } = state;
                const { notificationsSettings } = action.payload;
                const settings = _object_spread_props(_object_spread({}, account.settings), {
                    notifications: notificationsSettings
                });
                return _object_spread_props(_object_spread({}, state), {
                    account: _object_spread_props(_object_spread({}, state.account), {
                        settings
                    }),
                    fetching: unregisterAction(state.fetching, actionTypes.FETCH_NOTIFICATIONS_SETTING)
                });
            }
        case actionTypes.FETCH_NOTIFICATIONS_SETTING_ERROR:
            {
                return _object_spread_props(_object_spread({}, state), {
                    patientDataFromInvitation: null,
                    fetching: unregisterAction(state.fetching, actionTypes.FETCH_NOTIFICATIONS_SETTING),
                    errors: registerAction(state.errors, actionTypes.FETCH_NOTIFICATIONS_SETTING)
                });
            }
        //------------------------------------------------------------------------------------------------------------------
        default:
            {
                return state;
            }
    }
}
